import { useContext, useMemo } from 'react';
import { ChatViewType, ChatViewTypeContext } from '@/components/BrandInsights/context';

export const useIsFullPageChat = () => {
  const view = useContext(ChatViewTypeContext);

  return useMemo(() => {
    return view === ChatViewType.Page;
  }, [view]);
};